import { createContext, useContext, type ReactNode } from 'react';

import type { ConsoleApi } from './client';
import type { ApiMode } from './index';

export interface ApiContextValue {
  api: ConsoleApi;
  mode: ApiMode;
  baseUrl: string | null;
}

const ApiContext = createContext<ApiContextValue | null>(null);

export function ApiProvider({ value, children }: { value: ApiContextValue; children: ReactNode }) {
  return <ApiContext.Provider value={value}>{children}</ApiContext.Provider>;
}

export function useApiContext(): ApiContextValue {
  const value = useContext(ApiContext);
  if (!value) throw new Error('useApi must be used inside <ApiProvider>.');
  return value;
}

export function useApi(): ConsoleApi {
  return useApiContext().api;
}
